import {
  GettingStartedSection,
  BusinessSettingsSection,
  TripSettingsSection,
  SimulationSection,
  FleetSetupSection,
  OnboardingClientsSection,
  AddOnsSection,
} from "@/redux/slices/onboarding/types";
import type { QuickSetupSection } from "@/redux/slices/quickSetup/types";

export const SECTION_PATH_MAPPINGS: Record<QuickSetupSection, string[]> = {
  // Getting Started (matches GettingStartedSection)
  [GettingStartedSection.GENERAL_WALKTHROUGH]: [""],
  [GettingStartedSection.STRIPE]: ["/payments/payment-configuration"],

  // Business Settings (matches BusinessSettingsSection)
  [BusinessSettingsSection.BUSINESS_DETAILS]: ["/config/business/business-details"],
  [BusinessSettingsSection.WEBSITE_DETAILS]: ["/config/business/website-details"],
  [BusinessSettingsSection.EMAIL_NOTIFICATION_SETTINGS]: ["/config/business/email-notifications"],
  [BusinessSettingsSection.ACCESS_CONTROL]: ["/config/business/access-control"],
  [BusinessSettingsSection.DISPLAY_OPTIONS]: ["/config/business/display-options"],

  // Trip Settings (matches TripSettingsSection)
  [TripSettingsSection.TRIP_COST]: ["/config/trip/trip-cost"],
  [TripSettingsSection.TIME_DAY_MULTIPLIER]: ["/config/trip/time-and-day"],
  [TripSettingsSection.HOURLY_HIRE]: ["/config/trip/hourly-daily-hire"],
  [TripSettingsSection.TRANSFER_AND_VEHICLE_OPTIONS]: [
    "/config/trip/vehicle-types",
    "/config/trip/transfer-types",
    "config/trip/fixed-cost-extras",
  ],
  [TripSettingsSection.UNSCHEDULED_STOPS]: ["/config/trip/unscheduled-stops"],
  [TripSettingsSection.CANCELLATION_FEES]: ["/config/trip/cancellation-fees"],
  [TripSettingsSection.BILLING_SETTINGS]: ["/config/trip/billing-settings"],
  [TripSettingsSection.WAITING_TIMES]: ["/config/trip/waiting-times"],
  [TripSettingsSection.DISPATCH_SETTINGS]: ["/config/trip/dispatch-settings"],

  // Test Simulation (matches SimulationSection)
  [SimulationSection.CREATE_CLIENT]: ["/clients"],
  [SimulationSection.CREATE_DRIVER]: ["/drivers"],
  [SimulationSection.CREATE_VEHICLE]: ["/vehicles"],
  [SimulationSection.CREATE_BOOKING]: ["/clients"],

  // Fleet Setup (matches FleetSetupSection)
  [FleetSetupSection.ADD_OWN_VEHICLES]: ["/vehicles"],
  [FleetSetupSection.ADD_OWN_DRIVERS]: ["/drivers"],
  [FleetSetupSection.INVITE_OWN_PARTNER_DRIVERS]: ["/drivers"],

  // Client/Company Onboarding (matches OnboardingClientsSection)
  [OnboardingClientsSection.REGISTER_CLIENT]: ["/clients"],
  [OnboardingClientsSection.UPLOAD_CLIENTS]: ["/clients"],
  [OnboardingClientsSection.SETUP_COMPANY_PROFILE]: ["/companies"],

  // Add-ons (matches AddOnsSection)
  [AddOnsSection.SETUP_ADDONS]: ["/add-ons"],
};

export function isPathRelatedToSection(pathname: string, section: QuickSetupSection | null): boolean {
  if (!section) return false;

  const relatedPaths = SECTION_PATH_MAPPINGS[section];
  if (!relatedPaths) return false;

  return relatedPaths.some((path) => pathname.includes(path));
}
